const tabs = document.querySelectorAll('.js-block-product-head__tab');
const tabpanels = document.querySelectorAll('.js-block-product-head__tabpanel');
if (tabs.length) {
  [].forEach.call(tabs,(tab) => tab.addEventListener('click', toggleTab));

  // Set first active
  tabs[0].setAttribute('aria-expanded', true);
  tabpanels[0].classList.add('is-open');
}

function toggleTab(event) {
  const tab = event.target;
  const tabpanelId = tab.getAttribute('aria-controls');
  const tabpanel = document.getElementById(tabpanelId);

  // Reset
  [].forEach.call(tabs,(tab) => tab.setAttribute('aria-expanded', 'false'));
  [].forEach.call(tabpanels,(tabpanel) => tabpanel.classList.remove('is-open'));

  tab.setAttribute('aria-expanded', tab.getAttribute('aria-expanded') === 'false');

  if (tabpanel) {
    tabpanel.classList.toggle('is-open');
  }
}